import axios from "axios";
import { getUserFromLS } from "../utils/getUserFromLS";

export const deleteSocialPromptSeries = (
  seriesId: string,
  callback: () => void,
  errorCallback: (error: unknown) => void
) => {
  const token = getUserFromLS().access_token;
  const URL = `${import.meta.env.VITE_API_BASE_URL}/social_prompts/series/${encodeURIComponent(seriesId)}`;

  return axios(URL, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(() => {
      if (callback != null) {
        callback();
      }
    })
    .catch((error) => {
      if (errorCallback != null) {
        errorCallback(error);
      }
    });
};
